export default __webpack_public_path__ + "media/ml2020-grids.png";